import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

// Initial-load fallback for the SignalR push: returns
// [{ disputeId, hasUnread, latestCommentAt, latestCommentBy }] for the
// dispute IDs we're currently displaying. The dot is correct *before* any
// websocket message arrives.
export const fetchUnreadSummary = (disputeIds) =>
  apiClient(ENDPOINTS.COMMENT_LOG.UNREAD_SUMMARY(disputeIds), {
    method: "GET",
    suppressToast: true,
  });

// Upserts last_read_at = now for the current user + dispute. Server echoes
// "DisputeCommentRead" to the user's other tabs over the hub so dots clear
// across devices.
export const markDisputeCommentsRead = (disputeId) =>
  apiClient(ENDPOINTS.COMMENT_LOG.MARK_READ(disputeId), {
    method: "POST",
    suppressToast: true,
  });
